<mat-card appearance="outlined" class="main-div" *ngIf="shouldInfoShown">
    <h2><i class="fas fa-warning"></i> Solaranlagen sind keinem Standort zugeordnet <i class="fas fa-warning"></i></h2>
    Es gab ein Update, seitdem müssen alle Solaranlagen einem Standort zugeordnet werden. Bitte gehen Sie zur <a routerLink="/solar">Solar Übersichtsseite</a> und aktualisieren Sie die Standortinformationen
</mat-card>
